import { styled } from '@linaria/react';

import { colors, fonts, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
`;

export const SectionTitle = styled.h3`
  font-family: ${fonts.heading};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.medium};
  color: ${colors.fontPrimary};
  margin: 0;
`;

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;

  & > :first-child {
    border-right: 1px solid ${colors.borderGreyLighter};
  }
`;

export const AcceptedCardsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${space[2]};
`;

export const FormError = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${colors.error};
`;
